import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'
import { GetRecordUrlReq } from '@circusmonkey/spock-protobuf/ts/frontend/member_pb.js'
import Protobuf from '../../plugins/protobuf'

const client = new MembersClient(apiURL, null, null)

/**
 * 取下注記錄連結
 * @param func
 * @returns {Promise<unknown>}
 */
async function getRecordURL(params = {}, func = null) {
	console.log('params', params)
	const req = new GetRecordUrlReq()
	req.setLang(Protobuf.string(params))

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.getRecordUrl.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getRecordUrl(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'record url'))
		})
	}).then(resp => resp)
}

export {
	getRecordURL
}
